import React from 'react';
import './App.css';
import {BrowserRouter, Routes, Route } from "react-router-dom";
import NginxConfListPage from "./pages/ConfListPage";
import NginxConfEditPage from "./pages/ConfEditPage";
import 'antd/dist/reset.css';
import {App as AntdApp} from 'antd';
import {Bounce, ToastContainer} from "react-toastify";
import {IS_TEST} from "./utils/config";
import ServiceListPage from "./pages/ServiceListPage";
import HomePage from "./pages/HomePage";
import SslScriptPage from "./pages/SslScriptPage";
import RealtimeConfigPage from "./pages/RealtimeConfigPage";
import KmsPage from "./pages/KmsPage";

function App() {
  return (
    <AntdApp>
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<HomePage/>} />
                <Route path="/conf/list" element={<NginxConfListPage/>} />
                <Route path="/conf/edit/:domainName" element={<NginxConfEditPage/>} />
                <Route path="/service/list" element={<ServiceListPage/>} />
                <Route path="/ssl/script" element={<SslScriptPage/>} />
                <Route path="/realtime-config" element={<RealtimeConfigPage/>} />
                <Route path="/kms" element={<KmsPage/>} />
            </Routes>
        </BrowserRouter>
        <ToastContainer
            position="top-center"
            autoClose={2000}
            closeButton={false}
            hideProgressBar={true}
            newestOnTop={false}
            rtl={false}
            pauseOnFocusLoss={IS_TEST}
            pauseOnHover
            theme="light"
            transition={Bounce}
        />
    </AntdApp>
  );
}

export default App;
